import api from "../proxy/config";
import axios from "./axiosConfig";

const getHeaders = () => ({
    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("token"))}`,
});

const handleBackendError = (error, defaultMsg) => {
    if (error.response?.status === 500 || (typeof error.response?.data === 'string' && error.response.data.includes("Internal Server Error"))) {
        throw new Error("Si è verificato un problema, riprova più tardi.");
    }
    const backendError = error.response?.data;
    const message = typeof backendError === 'string' 
        ? backendError 
        : (backendError?.message || backendError?.error || defaultMsg);
    throw new Error(message);
};

export const searchCategoriesPaged = async (request) => {
    try {
        const response = await axios.post(`${api.ricercaCategorie}Avanzata`, request, {
            headers: getHeaders(),
        });
        return response.data;
    } catch (error) {
        handleBackendError(error, "Errore nella ricerca delle categorie");
    }
};

export const addCategory = async (request) => {
    try {
        const response = await axios.post(`${api.ricercaCategorie.replace('/ricerca', '/aggiungi')}`, request, {
            headers: getHeaders(),
        });
        return response.data;
    } catch (error) {
        handleBackendError(error, "Errore durante l'inserimento della categoria");
    }
};

export const updateCategory = async (request) => {
    try {
        const response = await axios.post(`${api.ricercaCategorie.replace('/ricerca', '/modifica')}`, request, {
            headers: getHeaders(),
        });
        return response.data;
    } catch (error) {
        handleBackendError(error, "Errore durante l'aggiornamento della categoria");
    }
};

export const deleteCategory = async (categoryId) => {
    try {
        const response = await axios.post(`${api.ricercaCategorie.replace('/ricerca', '/elimina')}`, categoryId, {
            headers: {
                ...getHeaders(),
                'Content-Type': 'application/json'
            },
        });
        return response.data;
    } catch (error) {
        handleBackendError(error, "Errore durante l'eliminazione della categoria");
    }
};

export const importCategoriesCsv = async (file) => {
    try {
        const formData = new FormData();
        formData.append("file", file);
        const response = await axios.post(`${api.ricercaCategorie.replace('/ricerca', '/import')}`, formData, {
            headers: {
                ...getHeaders(),
                "Content-Type": "multipart/form-data",
            },
        });
        return response.data;
    } catch (error) {
        handleBackendError(error, "Errore durante l'importazione CSV");
    }
};
 